var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-contact-wrap"},[_c('address',{staticClass:"header-contact"},[_c('a',{attrs:{"href":`tel:${_vm.phone}`}},[_c('h1',[_vm._v("Call or text")]),_c('h1',[_vm._v(_vm._s(_vm.phone))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }